const defineLegacyISO = (locale) => {
  switch (locale) {
    case 'de':
      return 'de-DE'
    case 'nl':
      return 'nl-NL'
    case 'fr':
      return 'fr-FR'
    case 'eo':
      return 'en-NL'
    case 'vo':
      return 'en-US'
    case 'io':
      return 'en-IN'
    case 'ua':
      return 'ua-UA'
    case 'hu':
      return 'hu-HU'
    case 'sv':
      return 'sv-SE'
    default:
      return locale
  }
}

const defineLegacyReverseISO = (locale) => {
  switch (locale) {
    case 'de-DE':
      return 'de'
    case 'nl-NL':
      return 'nl'
    case 'fr-FR':
      return 'fr'
    case 'en-NL':
      return 'eo'
    case 'en-US':
      return 'vo'
    case 'en-IN':
      return 'io'
    case 'ua-UA':
      return 'ua'
    case 'hu-HU':
      return 'hu'
    case 'sv-SE':
      return 'sv'
    default:
      return locale
  }
}

const defineShortLocale = (locale) => {
  const useRemap = defineLegacyISO(locale)
  const useShort = useRemap.split('-')
  return useShort[0]
}

export { defineLegacyISO, defineLegacyReverseISO, defineShortLocale }
